import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'jhi-column-filter-list',
    template: `
        <form #f='ngForm' class="needs-validation" [ngClass]="{'was-validated': f.touched}">
            <input type="text" class="form-control" placeholder="{{ listPlaceholder | translate}}"
                   pattern="^[\\d]+(,[\\d]+)*$" [(ngModel)]="filter.value" name="{{filter.key}}" data-test="columnFilterListInput">
            <br/>
            <div class="footer text-center"><br>
                <button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="!f.valid" (click)="apply(f)" data-test="columnFilterListApplyButton">{{ 'apply' | translate }}</button>
                <button class="btn btn btn-secondary btn-sm" (click)="reset(f)">{{ 'reset' | translate }}</button>
            </div>
        </form>
    `
})
export class ColumnFilterListComponent implements OnInit {
    @Input() filter: any;

    @Output() onApply = new EventEmitter();
    @Output() onReset = new EventEmitter();

    listPlaceholder: string;

    ngOnInit(): void {
        this.listPlaceholder = this.filter.placeholder ? this.filter.placeholder : 'column-filter.comma.separated.values.placeholder';
    }

    apply(form) {
        if (!form.valid) {
            return;
        }
        this.onApply.emit();
    }

    reset(form) {
        form.reset();
        this.onReset.emit();
    }
}
